import * as React from 'react';
import * as parse from 'date-fns/parse';
import * as distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import { observer } from 'mobx-react';

// Declarations
import { ISelectablePeopleItem } from './AppNetworkPeopleSearch';

// Components
import Box from '../../components/Box';
import Paper from '../../components/Paper';
import Typography from '../../components/Typography';

// Style
import './PeopleListItem.css';

// Component
export interface IProps {
  user: ISelectablePeopleItem;
  onClick: () => void;
}
function SelectablePeopleListItem({ user, onClick }: IProps) {
  const bg = 'linear-gradient(45deg, #FF4A5D 0%, #FF924A 100%)';
  return (
    <Paper
      className="AppWorkspacePeople__PeopleListItem"
      style={user.selected ? { background: bg, color: '#fff' } : undefined}
      onClick={onClick}
    >
      <img
        className="AppWorkspacePeople__PeopleListItem__avatar"
        src={user.photoUrl || '//i.imgur.com/wkbr0Z0.png'}
        height={96}
        width={96}
        style={{ minWidth: 96 }}
      />
      <div className="AppWorkspacePeople__PeopleListItem__content">
        <Typography
          color="inherit"
          className="AppWorkspacePeople__PeopleListItem__content__primary"
          type="subheading"
        >
          {`${user.firstName} ${user.lastName}`}
        </Typography>
        <Box mt={1}>
          <Typography
            color="inherit"
            className="AppWorkspacePeople__PeopleListItem__content__secondary"
            type="caption"
          >
            {`Active ${distanceInWordsToNow(parse(`${user.lastLogin}Z`))} ago`}
          </Typography>
        </Box>
      </div>
    </Paper>
  );
}

export default observer(SelectablePeopleListItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/SelectablePeopleListItem.tsx